import type { Garment } from "../types";

export const garments: Garment[] = [
  {
    name: "T-shirt",
    supplierName: "Basic o-shirt",
    imageUrl: "/images/basic-shirt.png",
    price: "249 / 299",
    defaultSize: "M",
    sizes: ["116", "122", "128", "134", "140", "146", "2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
  },
  {
    name: "T-shirt nättyg",
    supplierName: "Ultra o-shirt",
    imageUrl: "/images/ultra-shirt.png",
    price: "289",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  },
  {
    name: "T-shirt nättyg (vit)",
    supplierName: "Ultra o-shirt (vit)",
    imageUrl: "/images/ultra-shirt-white.png",
    price: "289",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
  },
  {
    name: "Linne",
    supplierName: "Flight singlet",
    imageUrl: "/images/race-singlet.png",
    price: "249",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Långärmad t-shirt",
    supplierName: "Basic long sleeve shirt",
    imageUrl: "/images/long-shirt.png",
    price: "349",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
  },
  {
    name: "Långa nylonbyxor",
    supplierName: "Long o-pants",
    imageUrl: "/images/long-opants.png",
    price: "289",
    defaultSize: "M",
    sizes: ["128", "134", "140", "2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Knälånga nylonbyxor",
    supplierName: "Race O-pants",
    imageUrl: "/images/half-opants.png",
    price: "249",
    defaultSize: "M",
    sizes: ["128", "134", "140", "XXS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Långa tights",
    supplierName: "Tights long",
    imageUrl: "/images/long-tights.png",
    price: "319",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Korta tights",
    supplierName: "Tights low",
    imageUrl: "/images/short-tights.png",
    price: "269",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Överdragsjacka",
    supplierName: "Track suit jacket",
    imageUrl: "/images/jacket.png",
    price: "590 / 690",
    defaultSize: "M",
    sizes: ["130", "140", "150", "2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Överdragsbyxor",
    supplierName: "Track suit pants",
    imageUrl: "/images/pants.png",
    price: "390 / 490",
    defaultSize: "M",
    sizes: ["130", "140", "150", "2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Överdragsjacka vinter",
    supplierName: "Winter suit jacket",
    imageUrl: "/images/jacket.png",
    price: "890",
    defaultSize: "M",
    sizes: ["130", "140", "150", "2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Överdragsbyxor vinter",
    supplierName: "Winter suit pants",
    imageUrl: "/images/pants.png",
    price: "720",
    defaultSize: "M",
    sizes: ["130", "140", "150", "2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Väst",
    supplierName: "Vest",
    imageUrl: "/images/vest.png",
    price: "490",
    defaultSize: "M",
    sizes: ["130", "140", "150", "2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Löparjacka",
    supplierName: "Run protect jacket",
    imageUrl: "/images/run-jacket.png",
    price: "790",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Löpartröja",
    supplierName: "Fly shirt",
    imageUrl: "/images/run-shirt.png",
    price: "319",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Skiddräkt tröja",
    supplierName: "Race Ski shirt",
    imageUrl: "/images/ski-shirt.png",
    price: "590",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Skiddräkt byxor",
    supplierName: "Race ski pants",
    imageUrl: "/images/ski-pants.png",
    price: "490",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Cykeljersy",
    supplierName: "Jersy basic",
    imageUrl: "/images/cycle-shirt.png",
    price: "450",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "Cykelbyxor",
    supplierName: "BIB shorts basic",
    imageUrl: "/images/BIB-shorts.png",
    price: "450",
    defaultSize: "M",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
  },
  {
    name: "OL-strumpor",
    supplierName: "O-socks PRO",
    imageUrl: "/images/o-socks.png",
    price: "179",
    defaultSize: "38-40",
    sizes: ["30-33", "34-37", "38-40", "41-43", "44-46"],
  },
  {
    name: "Pannband 7cm",
    supplierName: "Headband PRO 7cm",
    imageUrl: "/images/headband-7.png",
    price: "75",
    defaultSize: "M",
    sizes: ["S", "M", "L"],
  },
  {
    name: "Pannband 4cm",
    supplierName: "Headband PRO 4cm",
    imageUrl: "/images/headband-4.png",
    price: "45",
    defaultSize: "M",
    sizes: ["S", "M", "L"],
  },
  {
    name: "Pannband 11cm i microfleece",
    supplierName: "Headband Wide",
    imageUrl: "/images/headband-wide.png",
    price: "99",
    defaultSize: "58",
    sizes: ["56", "58", "60"],
  },
  {
    name: "Buff",
    supplierName: "Tube",
    imageUrl: "/images/tube.png",
    price: "65",
    defaultSize: "One size",
    sizes: ["One size"],
  },
  {
    name: "Mössa",
    supplierName: "Hat S3",
    imageUrl: "/images/pro-hat.png",
    price: "149",
    defaultSize: "58",
    sizes: ["56", "58", "60"],
  },
];
